import { createContext } from 'react';

export const InitialState = {
  // Old synchronous flow (single doc + stakeholders via subscription)
  startBulkDownloadDocumentsJob: () => {},
  clearJobId: () => {},
  jobId: null,
  progress: 0,
  message: null,
  finished: true,
  filename: null,
  url: null,
  jobErrors: [],

  // New async flow (bulk downloads from policy/client/product pages via email)
  enqueueBulkDownloadDocuments: () => {},

  // Shared
  loading: false,
  error: null
};

export const BulkDownloadDocumentsJobContext = createContext(InitialState);

BulkDownloadDocumentsJobContext.displayName = 'BulkDownloadDocumentsJobContext';
